import { render, staticRenderFns } from "./UpdateQuantity.vue?vue&type=template&id=237b8e8c&scoped=true&"
import script from "./UpdateQuantity.vue?vue&type=script&lang=js&"
export * from "./UpdateQuantity.vue?vue&type=script&lang=js&"
import style0 from "./UpdateQuantity.vue?vue&type=style&index=0&id=237b8e8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237b8e8c",
  null
  
)

export default component.exports